import { render, staticRenderFns } from "./historico-sac-component.vue?vue&type=template&id=0417352c&"
import script from "./historico-sac-component.vue?vue&type=script&lang=ts&"
export * from "./historico-sac-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0417352c')) {
      api.createRecord('0417352c', component.options)
    } else {
      api.reload('0417352c', component.options)
    }
    module.hot.accept("./historico-sac-component.vue?vue&type=template&id=0417352c&", function () {
      api.rerender('0417352c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/historico-sac-component.vue"
export default component.exports